import KoulutusmuodonEtusivu from "@/components/03-templates/KoulutusmuodonEtusivu";
import Jarjestajaluettelo from "./Jarjestajaluettelo";
import { getKoulutusmuodot } from "@/utils/common";
import { useIntl } from "react-intl";
import WizardContainer from "./WizardContainer";
import JarjestamislupaJSX from "./JarjestamislupaHTML";
import { PaikallisenTietovarastonAvain } from "@/enums";

/**
 * Hakuavaimet, joiden perusteella basedata.jsx täydentää lokaalia
 * tietovarastoa. Näiden avaimien mukaista dataa tarvitaan laajasti kyseisen
 * koulutusmuodon sivuilla.
 **/
const hakuavaimet = [
  PaikallisenTietovarastonAvain.AJALLA,
  PaikallisenTietovarastonAvain.JOISTA_LISAKSI,
  PaikallisenTietovarastonAvain.KUJALISAMAAREET,
  "kohteet",
  "kunnat",
  "lisatietoja",
  "lupaByUuid",
  "maakuntakunnat",
  "maaraystyypit",
  "tulevatLuvat",
  "kieletOPH"
];

export default function TUVA() {
  const intl = useIntl();

  const koulutusmuoto = getKoulutusmuodot(intl).tuva;

  return (
    <KoulutusmuodonEtusivu
      hakuavaimet={hakuavaimet}
      Jarjestajaluettelo={Jarjestajaluettelo}
      jarjestajatOtsikko={koulutusmuoto.jarjestajatOtsikko}
      JarjestamislupaJSX={JarjestamislupaJSX}
      koulutusmuoto={koulutusmuoto}
      kuvausteksti={koulutusmuoto.kuvausteksti}
      paasivunOtsikko={koulutusmuoto.paasivunOtsikko}
      WizardContainer={WizardContainer}></KoulutusmuodonEtusivu>
  );
}
